import 'ids-enterprise-wc/components/ids-dropdown/ids-dropdown';
import 'ids-enterprise-wc/components/ids-list-box/ids-list-box';
import 'ids-enterprise-wc/components/ids-list-box/ids-list-box-option';
import type { PropertyDescriptor } from '../types';

class IdsDropdownEditor extends HTMLElement {
  private _value: string = '';
  private _isExpression: boolean = false;
  private _propertyDescriptor: PropertyDescriptor | null = null;

  get value(): string {
    return this._value;
  }

  set value(val: string) {
    this._value = val;
    const dropdown = this.querySelector('ids-dropdown') as HTMLElement & { value: string } | null;
    if (dropdown) dropdown.value = val;
  }

  get isExpression(): boolean {
    return this._isExpression;
  }

  set isExpression(val: boolean) {
    this._isExpression = val;
  }

  get propertyDescriptor(): PropertyDescriptor | null {
    return this._propertyDescriptor;
  }

  set propertyDescriptor(val: PropertyDescriptor | null) {
    this._propertyDescriptor = val;
    if (this.isConnected) this.render();
  }

  connectedCallback(): void {
    this.style.display = 'block';
    this.style.width = '100%';
    this.render();
  }

  private render(): void {
    const options = this._propertyDescriptor?.options ?? [];
    const label = this._propertyDescriptor?.label ?? '';
    const description = this._propertyDescriptor?.description ?? '';

    const optionsHtml = options
      .map(o => `<ids-list-box-option value="${o.value}">${o.label}</ids-list-box-option>`)
      .join('');

    const descAttr = description ? ` description="${description}"` : '';

    this.innerHTML = `
      <ids-dropdown value="${this._value}" label="${label}"${descAttr}>
        <ids-list-box>${optionsHtml}</ids-list-box>
      </ids-dropdown>
    `;

    const dropdown = this.querySelector('ids-dropdown');
    if (dropdown) {
      dropdown.addEventListener('change', (e: Event) => {
        const target = e.target as HTMLElement & { value: string };
        this._value = target.value;
        this.dispatchEvent(new CustomEvent('valueChanged', {
          detail: { value: this._value },
          bubbles: true,
        }));
      });
    }
  }
}

customElements.define('ids-dropdown-editor', IdsDropdownEditor);
